import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarTramites(axios, parametros) {    
    parametros.operacao = 'buscarTramites';   

    let retorno = {};

    await axios.santriGET('/rest/sugestaoTramite', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async enviarTramite(axios, parametros) {  
    parametros.operacao = 'enviarTramite';

    let retorno = {};

    await axios.santriPOST('/rest/sugestaoTramite', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async excluirTramite(axios, parametros) {  
    parametros.operacao = 'excluirTramite';

    let retorno = {};

    await axios.santriPOST('/rest/sugestaoTramite', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

}


// WEBPACK FOOTER //
// ./src/components/Rest/RSugestaoTramite.js